<template>
  <v-autocomplete
    :items="getLoadedUsers"
    item-value="id"
    item-text="displayName"
    v-model="currentUser"
    v-bind="$attrs"
    @change="emitUser($event)"
    autocomplete
  >
    <template slot="item" slot-scope="item">{{ item.item.displayName }}</template>

    <template slot="no-data">
      <v-layout row wrap>
        <v-flex pa-2 d-flex>Please add a new person:</v-flex>
      </v-layout>
    </template>
    <template slot="append-item">
      <v-divider></v-divider>

      <v-form ref="form" v-model="valid">
        <v-layout row wrap>
          <v-flex pa-2 d-flex>
            <v-input hide-details>
              <v-text-field
                v-model="editing.name"
                label="Name"
                required
                :rules="nameRules"
                background-color="transparent"
                solo
                @keyup.enter="save()"
              ></v-text-field>

              <v-text-field
                v-model="editing.email"
                label="Email"
                solo
                background-color="transparent"
                required
                :rules="emailRules"
                @keyup.enter="save()"
              ></v-text-field>

              <template slot="append">
                <v-btn icon color="primary" @click="save()">
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
            </v-input>
          </v-flex>
        </v-layout>
      </v-form>
    </template>
  </v-autocomplete>
</template>

<i18n>
{
  "de": {
    "create_user_label": "Neue Person hinzufügen",
    "cancel": "Abbrechen",
    "save": "Speichern"
  },
  "en": {
    "create_user_label": "Add new person",
    "cancel": "Cancel",
    "save": "Save"
  }
}
</i18n>

<script>
import { mapGetters, mapActions } from "vuex";
import { api } from "@/store/modules/users";

export default {
  props: {
    selectedUser: {
      type: [String, Array],
      default: ""
    }
  },
  mounted() {
    console.log("UID", this.selectedUser);
    this.currentUser = this.selectedUser;
  },
  data: () => ({
    currentUser: "",
    editing: {
      name: "",
      email: ""
    },
    valid: false,
    nameRules: [v => !!v || "Name is required"],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ]
  }),
  computed: {
    ...mapGetters(api.namespace, [
      api.getters.getLoadedUsers,
      api.getters.getUser
    ])
  },
  methods: {
    ...mapActions(api.namespace, [api.actions.createUserInactive]),
    async save() {
      if (this.$refs.form.validate()) {
        const payload = {
          data: {
            displayName: this.editing.name,
            email: this.editing.email
          }
        };

        const x = await this.createUserInactive(payload);
        if (this.currentUser instanceof Array) {
          this.currentUser.push({ ...payload.data, id: x });
        } else {
          this.currentUser = { ...payload.data, id: x };
          this.$emit("update:selectedUser", x);
        }

        console.log("Ready for Close");
        this.editing.name = "";
        this.editing.email = "";
      }
    },
    emitUser(event) {
      this.$emit("update:selectedUser", event);
    }
  }
};
</script>
